export const groups = ['all', 'assignee', 'assigner', 'watched']
export const groupIcons = {
  all: 't-my-tasks-overview',
  watched: 'eye',
  assigner: 't-my-tasks-assigner',
  assignee: 't-my-tasks-assignee'
}
export const subsets = ['today', 'starting_soon', 'due_soon', 'overdue', 'unscheduled']
